import * as types from '../constants/actionTypes';
// import objectAssign from 'object-assign';
const initialState = {
	appointmentList: [],
	specialistAvailability: {},
	appointmentData: {},
	appointmentDetailsData: {},
	appointmentDetails: {},
	patientHistory: {},
	patientDetails: {},
	patientAllHistory: [],
	sessionData: [],
	ratingQuestions: [],
	patientAllConsultHistory: {},
	ratingSucess: false,
	specialistBlockedDates: null
};

//state has been changed to initialstate from []
export default function appointmentReducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_APPOINTMENTS:
			return {
				...state,
				appointmentList: action.appointmentList,
				pendingRate: action.appointmentList.pendingRate ? action.appointmentList.pendingRate : ''
			};
		case types.GET_SPECIALISTAVABILITY:
			return {
				...state,
				specialistAvailability: action.specialistAvailability
			};
		case types.BOOK_APPOINTMENT:
			return {
				...state,
				appointmentData: action.appointmentData
			};
		case types.ADD_APPOINTMENT_DETAILS:
			return {
				...state,
				addAppointmentDetails: action.addAppointmentDetails
			};
		case types.DELETE_APPOINTMENT:
			return {
				...state,
				appointmentDetailsData: action.appointmentDetailsData
			};
		case types.GET_APPOINTMENT_DETAILS:
			return {
				...state,
				appointmentDetails: action.appointmentDetails
			};
		case types.CANCEL_APPOINTMENT:
			return {
				...state,
				appointmentCancel: action.appointmentCancel
			};
		case types.GET_SPECIALIST_DETAIL_CALENDAR:
			return {
				...state,
				specialistDetailsCalendar: action.specialistDetailsCalendar
			};
		case types.GET_PATIENT_HISTORY:
			return {
				...state,
				patientHistory: action.patientHistory
			};
		case types.CREATE_SESSIONID_TOKEN:
			return {
				...state,
				sessionData: action.sessionData
			};
		case types.GET_CONSULTATION_DETAIL:
			return {
				...state,
				consultationDet: action.consultationDet
			};
		// case types.GET_PATIENT_ALL_HISTORY:
		// 	return { ...state,
		// 		patientDetails: action.patientDetails
		// 	};
		case types.GET_PATIENT_ALL_HISTORY:
			return {
				...state,
				patientAllHistory: action.patientAllHistory
			};
		case types.GET_PATIENT_ALL_CONSULT_HISTORY:
			return {
				...state,
				patientAllConsultHistory: action.patientAllConsultHistory
			};

		case types.GET_RATING_QUESTIONS:
			return {
				...state,
				ratingQuestions: action.ratingQuestions
			};
		case types.ADD_RATING:
			return {
				...state,
				pendingRate: action.pendingRate,
				ratingSucess: action.ratingSucess
			};
		case types.NO_SHOW_APPOINTMENT:
			return {
				...state,
				noShowappointmentList: action.noShowappointmentList
			};

		case types.GET_APPOINTMENTS_FOR_HEALTH_RECORD:
			return {
				...state,
				appointmentList: action.appointmentList
			};

		case types.DONT_REMIND_FEEDBACK_AGAIN:
			return {
				...state,
				pendingRate: action.pendingRate
			};

		case types.GET_REMINDER_FEEDBACK:
			return {
				...state,
				pendingRate: action.pendingRate
			};

		case types.STRIPE_PAYMENT:
			return {
				...state,
				paymentDetails: action.paymentDetails
			};

		case types.GET_APPOINTMENT_DETAIL_RATE:
			return {
				...state,
				appointmentRateDetail: action.appointmentRateDetail
			};

		case types.GET_SPECIALIST_BLOCK_DATES:
			return {
				...state,
				specialistBlockedDates: action.blockedDates
			};
		case types.GET_APPOINTMENT_RECEIPT:
			return {
				...state,
				appointmentReceipt: action.appointmentReceipt
			};
		case types.GET_DISPUTED_APPOINTMENTS:
			return {
				...state,
				disputedAppointments: action.disputedAppointments
			};

		default:
			return state;

	}
}

